module.exports = __webpack_public_path__ + "static/media/thumb_maxius_503x503.28e9e53a.jpg";